import { render, staticRenderFns } from "./Artistas.vue?vue&type=template&id=8b3e7a2c"
import script from "./Artistas.vue?vue&type=script&lang=js"
export * from "./Artistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports